var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qty-wrap rounded-sm w-100",class:{
    'not-empty': _vm.quantity > 0,
    'no-border': _vm.quantity < 1
  },on:{"mousedown":function($event){$event.stopPropagation();}}},[(_vm.enableAcqBox && _vm.product.logisticPackagingItems && _vm.quantity <= 0)?_c('v-btn',{staticClass:"btn-add-box",class:_vm.mode === 'list' ? 'mr-1' : 'mr-auto',attrs:{"aria-label":`${_vm.product.logisticPackagingItems} pezzi - Aggiungi un cartone da ${_vm.product.logisticPackagingItems} al carrello`,"color":"primary","outlined":"","height":"45","small":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.addToCart(
        _vm.product.logisticPackagingItems,
        undefined,
        {
          searchUid: _vm.product.searchUid,
          position: _vm.position
        },
        _vm.level
      )}}},[_c('div',[_vm._v(" "+_vm._s(_vm.product.logisticPackagingItems)+" "),_c('v-icon',{attrs:{"color":"primary","small":"","aria-hidden":"true"}},[_vm._v("$pack")])],1),_c('div',{staticClass:"text-uppercase small"},[_vm._v(" pezzi ")])]):_vm._e(),_c('v-btn',{staticClass:"minus",attrs:{"tile":"","aria-label":"Diminuisci quantità","depressed":"","color":"grey lighten-2","small":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.minus(
        true,
        { infos: { ..._vm.selectedOptions } },
        {
          searchUid: _vm.product.searchUid,
          position: _vm.position
        },
        _vm.level
      )},"mousedown":function($event){$event.stopPropagation();}}},[_c('v-icon',[_vm._v("$minus")])],1),_c('div',{staticClass:"val-cnt"},[_c('span',{staticClass:"val"},[_vm._v(_vm._s(_vm.quantity)+_vm._s(_vm.unit))]),_c('span',{staticClass:"small"},[_vm._v(_vm._s(_vm.quantityPerUnit))])]),_c('v-btn',{staticClass:"plus",class:_vm.quantity > 0 ? '' : 'rounded-sm',attrs:{"tile":"","aria-label":"Aumenta quantità","small":"","depressed":"","color":_vm.quantity > 0 ? 'grey lighten-2' : 'primary'},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleAdd(
        true,
        {
          infos: {
            ..._vm.selectedOptions
          }
        },
        {
          searchUid: _vm.product.searchUid,
          position: _vm.position
        },
        _vm.level
      )}}},[(_vm.quantity > 0)?_c('v-icon',[_vm._v("$plus")]):[_c('v-icon',[_vm._v("$cart")]),(_vm.label)?_c('span',{staticClass:"font-weight-bold white--text text-uppercase"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }